export default "__VITE_ASSET__CUdVxKSF__"